<script setup lang="ts">
import kebabCase from 'lodash/kebabCase';
import { computed } from 'vue';

import bankIcon from '@/assets/bank-icon.svg';
import americanExpressLogo from '@/assets/logos/american-express.svg';
import applePayLogo from '@/assets/logos/apple-pay-logo.svg';
import discoverLogo from '@/assets/logos/discover.svg';
import mastercardLogo from '@/assets/logos/mastercard.svg';
import paypalLogo from '@/assets/logos/paypal-logo.svg';
import shopPayLogo from '@/assets/logos/shop-pay-logo.svg';
import visaLogo from '@/assets/logos/visa.svg';

const props = defineProps<{
  cardType?: string;
}>();

const svgs = new Map([
  ['american-express', { source: americanExpressLogo, altCopy: 'American Express' }],
  ['discover', { source: discoverLogo, altCopy: 'Discover' }],
  ['mastercard', { source: mastercardLogo, altCopy: 'Mastercard' }],
  ['visa', { source: visaLogo, altCopy: 'Visa' }],
  ['apple-pay', { source: applePayLogo, altCopy: 'Apple Pay' }],
  ['paypal', { source: paypalLogo, altCopy: 'PayPal' }],
  ['shop-pay', { source: shopPayLogo, altCopy: 'Shop Pay' }],
  ['us-bank-account', { source: bankIcon, altCopy: 'bank icon' }],
]);
const normalizedCardType = computed(() => kebabCase(props.cardType?.toLowerCase()));
const logo = computed(() => svgs.get(normalizedCardType.value));
</script>

<template>
  <img
    v-if="logo?.source"
    :class="{ 'h-5': normalizedCardType === 'us-bank-account' }"
    :src="logo.source"
    :alt="logo.altCopy"
  />
</template>
